import * as apiActions from '@configuratorware/configurator-frontendgui/App/Reducers/Actions';
import { setConf } from '@configuratorware/configurator-frontendgui/App/configuration';
import { doCalculation } from '@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Actions';
import { Services } from '@configuratorware/configurator-frontendgui/App/ServiceLocator';

export const actionTypes = {
  SET_WEHA_LINES: 'SET_WEHA_LINES',
  SET_WEHA_GLOBAL_SETTINGS: 'SET_WEHA_GLOBAL_SETTINGS',
  SET_WEHA_SELECTED_LINE_ID: 'SET_WEHA_SELECTED_LINE_ID',
  SET_WEHA_SELECTED_LINE_IDS: 'SET_WEHA_SELECTED_LINE_IDS',
  SET_WEHA_CANVAS_DATA: 'SET_WEHA_CANVAS_DATA',
  RECEIVE_WEHA_FONT_DATA: 'RECEIVE_WEHA_FONT_DATA',
  SET_DISPLAY_NET_PRICES: 'SET_DISPLAY_NET_PRICES',
  SET_IS_ON_DEMAND_PRICE: 'SET_IS_ON_DEMAND_PRICE',
  RECEIVE_ADD_TO_CART: 'RECEIVE_ADD_TO_CART',
};

export const setWehaLines = (lines) => ({
  type: actionTypes.SET_WEHA_LINES,
  lines,
});

export const setWehaGlobalSettings = (globalSettings) => ({
  type: actionTypes.SET_WEHA_GLOBAL_SETTINGS,
  globalSettings,
});

export const setWehaSelectedLineId = (selectedLineId: string | null) => ({
  type: actionTypes.SET_WEHA_SELECTED_LINE_ID,
  selectedLineId,
});

export const setWehaSelectedLineIds = (selectedLineIds: string[]) => ({
  type: actionTypes.SET_WEHA_SELECTED_LINE_IDS,
  selectedLineIds,
});

export const setWehaCanvasData = (canvasData: object | null) => ({
  type: actionTypes.SET_WEHA_CANVAS_DATA,
  canvasData,
});

export const receiveFontData = (data: unknown) => ({
  type: actionTypes.RECEIVE_WEHA_FONT_DATA,
  data,
});

function fontDataReceiver(data: unknown) {
  return receiveFontData(Array.isArray(data) ? data : []);
}

export const getFontData = (dispatch: (action: unknown) => void) => {
  dispatch(apiActions.fetchData('font-data', fontDataReceiver));
};

/** Toggles net/gross display; syncs package getConf('displayNetPrices') so AmountPrice container shows netTotalFormatted or totalFormatted. */
export const setDisplayNetPrices = (displayNet: boolean) => (dispatch: (action: unknown) => void) => {
  setConf('displayNetPrices', displayNet);
  dispatch({ type: actionTypes.SET_DISPLAY_NET_PRICES, value: displayNet });
  dispatch(doCalculation());
};

export const setIsOnDemandPrice = (isOnDemand: boolean) => ({
  type: actionTypes.SET_IS_ON_DEMAND_PRICE,
  value: isOnDemand,
});

export const addToCart =
  () =>
  (dispatch: (action: unknown) => void, getState: () => { configurator: { configuration: object } }) => {
    const ebootisCustomerId = '_ebootis_customer_id';
    const query = new URLSearchParams(location.search);
    const customerId = query.has(ebootisCustomerId) ? query.get(ebootisCustomerId) : '';
    dispatch(
      apiActions.postData(
        'order',
        { configuration: getState().configurator.configuration, configurationtype: 'cart' },
        (data) => {
          if (!data?.error && data?.exportStatus?.errorMessage === null) {
            Services.ui.toggle('globalLoader', false);
            return { type: actionTypes.RECEIVE_ADD_TO_CART, data };
          } else {
            Services.ui.toggle('globalLoader', false);
            return { type: 'NETWORK_ERROR', error: data?.exportStatus?.errorMessage };
          }
        },
        {
          params: {
            [ebootisCustomerId]: customerId,
          },
        }
      )
    );
  };
